import {useState} from "react";
import Master from "./Master";

function Appointment(){


 const [selectedDate, setSelectedDate] = useState("");

  const timeSlots = [
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "12:30 PM",
  "1:00 PM",
  "1:30 PM",
  "5:00 PM",
  "5:30 PM",
  "6:00 PM",
  "6:30 PM"
];

const convertToMinutes = (time) => {
  const [t, modifier] = time.split(" ");
  let [hours, minutes] = t.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  return hours * 60 + minutes;
};

const isToday = (date) => {
  const today = new Date().toISOString().split("T")[0];
  return date === today;
};

const currentMinutes = new Date().getHours() * 60 + new Date().getMinutes();

const filteredSlots = isToday(selectedDate)
  ? timeSlots.filter((time) => convertToMinutes(time) > currentMinutes)
  : timeSlots;





const handleSubmit = async (e) => {
  e.preventDefault();

  const formData = {
    name: e.target.name.value,
    email: e.target.email.value,
    phone: e.target.phone.value,
    subject: e.target.subject.value,
    date: e.target.date.value,
    time: e.target.time.value,
  };

  try {
    const res = await fetch("https://drpatangecitydentalclinic.com/api/appointment.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const data = await res.json();
    alert(data.message);

  } catch (err) {
    console.error(err);
    alert("Something went wrong");
  }
};

    return(
        <Master>
                {/* Page Header Start */}
	<div className="page-header">
		<div className="container">
			<div className="row">
				<div className="col-lg-12">
					{/* Page Header Box Start */}
					<div className="page-header-box">
						<h1 className="text-anime-style-2" data-cursor="-opaque"><span>Make An</span> Appointment</h1>
						<nav className="wow fadeInUp">
							<ol className="breadcrumb">
								<li className="breadcrumb-item"><a href="./">home</a></li>
								<li className="breadcrumb-item active" aria-current="page">Make An Appointment</li>
							</ol>
						</nav>
					</div>
					{/* Page Header Box End */}
				</div>
			</div>
		</div>
	</div>
	{/* Page Header End */}

    {/* Page Appointment Start */}
    <div className="page-book-appointment">
        <div className="container">
			<div className="book-appointment-form">
				<div className="row section-row">
					<div className="col-lg-12">
						{/* Section Title Start */}
						<div className="section-title">
							<h3 className="wow fadeInUp">booking</h3>
							<h2 className="text-anime-style-2" data-cursor="-opaque"><span>Book</span> Appointment</h2>
						</div>
						{/* Section Title End */}
					</div>
				</div>

				<div className="row">
					<div className="col-lg-12">
						<div className="appointment-form wow fadeInUp">
							{/* Form Start */}
							<form onSubmit={handleSubmit} id="appointmentForm" action="#" method="POST" data-toggle="validator">
								<div className="row">
									<div className="form-group col-md-6 mb-4">
										<input type="text" name="name" className="form-control" id="name" placeholder="Enter Name" required />
										<div className="help-block with-errors"></div>
									</div>

									<div className="form-group col-md-6 mb-4">
										<input type="email" name ="email" className="form-control" id="email" placeholder="Enter Email" required />
										<div className="help-block with-errors"></div>
									</div>

									<div className="form-group col-md-6 mb-4">
										<input type="text" name="phone" className="form-control" id="phone" placeholder="Phone Number" required />
										<div className="help-block with-errors"></div>
									</div>

									<div className="form-group col-md-6 mb-4">
										<input type="text" name="subject" className="form-control" id="subject" placeholder="Subject" required/>
										<div className="help-block with-errors"></div>
									</div>

									<div className="form-group col-md-6 mb-4">
										<input type="date" name="date" className="form-control" min={new Date().toISOString().split("T")[0]} required onChange={(e) => setSelectedDate(e.target.value)}/>										<div className="help-block with-errors"></div>
									</div>

                                    <div className="form-group col-md-6 mb-4">
                                   <select name="time" className="form-control" required>
										<option value="">Select Time</option>
										{filteredSlots.map((time, index) => (
											<option key={index} value={time}>  {time}
											 </option> ))}
										</select>
                                    <div className="help-block with-errors"></div>
									</div>

									<div className="col-md-12">
										<button type="submit" className="btn-default">book appointment</button>
										<div id="msgSubmit" className="h3 hidden"></div>
									</div>
								</div>
							</form>
							{/* Form End */}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
    {/* Page Appointment End */}
        </Master>
    );
}

export default Appointment;